import { CalendarDays, MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import { useLocation } from "react-router-dom";

export default function FloatingSocials() {
  const location = useLocation();

  const openCalendly = () => {
    window.open("https://calendly.com/santhiladatabot/30min", "_blank");
  };

  const openWhatsApp = () => {
    window.open("https://wa.me/7373070033", "_blank");
  };

  // Do not render on blog pages
  if (location.pathname.startsWith('/blog')) {
    return null;
  }

  return (
    <div className={cn('fixed', 'right-1', 'top-[20%]', 'z-50')}>
      <div className={cn('flex', 'flex-col', 'gap-3', 'rounded-[28px]', 'bg-red-600', 'p-2', 'shadow-2xl')}>
        {/* Calendar */}
        <button
          aria-label="Schedule a Free Strategy Call"
          onClick={openCalendly}
          className={cn('flex', 'h-12', 'w-12', 'cursor-pointer', 'items-center', 'justify-center', 'rounded-2xl', 'bg-white', 'transition', 'hover:scale-105')}
        >
          <CalendarDays className={cn('h-5', 'w-5', 'text-red-600')} />
        </button>

        {/* WhatsApp */}
        <button
          aria-label="Contact us on WhatsApp"
          onClick={openWhatsApp}
          className={cn('flex', 'h-12', 'w-12', 'cursor-pointer', 'items-center', 'justify-center', 'rounded-2xl', 'bg-white', 'transition', 'hover:scale-105')}
        >
          <MessageCircle className={cn('h-5', 'w-5', 'text-green-500')} />
        </button>
      </div>
    </div>
  );
}
